import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const CalculationIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 12H7V14H9V12Z" fill={color} />
    <path d="M13 12H11V14H13V12Z" fill={color} />
    <path d="M17 12H15V14H17V12Z" fill={color} />
    <path d="M8.98047 15.9805H6.98047V17.9805H8.98047V15.9805Z" fill={color} />
    <path d="M12.9102 16H10.9102V18H12.9102V16Z" fill={color} />
    <path d="M17 15.9805H15V17.9805H17V15.9805Z" fill={color} />
    <path
      d="M19 2.5H5C4.17 2.5 3.5 3.17 3.5 4V20C3.5 20.83 4.17 21.5 5 21.5H19C19.83 21.5 20.5 20.83 20.5 20V4C20.5 3.17 19.83 2.5 19 2.5ZM19 20H5V4H19V20Z"
      fill={color}
    />
    <path d="M17.0205 6.00977H6.98047V9.99977H17.0205V6.00977Z" fill={color} />
  </svg>
);

export default CalculationIcon;
